import React, { useState } from 'react'
import SkinAssessmentHeader from './components/skinAssessmentHeader/SkinAssessmentHeader'
import './SkinAssessmentLayout.scss'
import SkinAssessmentQuestionFooter from './components/skinAssessmentQuestionFooter/SkinAssessmentQuestionFooter'
import { SkinAssessmentFooterContext } from './SkinAssessmentFooterContext'
import { SkinAssessmentHeaderContext } from './SkinAssessmentHeaderContext'

const SkinAssessmentLayout = ({ children }) => {
    const [handleAction, setHandleAction] = useState(null);
    const [headerAction, setHeaderAction] = useState(null);

    return (
        <SkinAssessmentFooterContext.Provider value={setHandleAction}>
            <SkinAssessmentHeaderContext.Provider value={setHeaderAction}>
                <div className="skin-assessment-wrapper">
                    <div className="skin-asm-header">
                        <SkinAssessmentHeader headerAction={headerAction} showHomeButton={false} />
                    </div>
                    <div className='skin-assessment-content-container'>
                        {children}
                    </div>
                    <SkinAssessmentQuestionFooter {...handleAction} />
                </div>
            </SkinAssessmentHeaderContext.Provider>
        </SkinAssessmentFooterContext.Provider>
    )
}

export default SkinAssessmentLayout
